import {Companies, Rosters} from "./models.js";

function Draft() {

    // Strings
    const name = null;
    const type = null;
    const currentPickBrand = null;

    // Boolean
    const ended = false;
    const postEndRun = false;

    // Arrays
    const brands = [];
    const protectedSuperstarsIds = [];
    const rosterPickOrderIds = [];

    // Objects
    const settings = {};
    const result = {};

    // Foreign keys
    const currentPickRosterId = null;

    return {
        name,
        type,
        currentPickBrand,
        ended,
        postEndRun,
        brands,
        protectedSuperstarsIds,
        rosterPickOrderIds,
        settings,
        result,
        currentPickRosterId,
    };
}

function addDraftCompanies(draft, companies) {
    companies.forEach(c => {
        c.draftId = draft.$loki
    });
}

function removeDraftCompanies(draft, companies) {
    companies.forEach(c => {
        c.draftId = null
    });
}

function getDraftCompanies(draft) {
    return Companies.find({'draftId': draft.$loki});
}

function addDraftRosters(draft, rosters) {
    rosters.forEach(c => {
        c.draftId = draft.$loki
    });
}

function removeDraftRosters(draft, rosters) {
    rosters.forEach(c => {
        c.draftId = null
    });
}

function getDraftRosters(draft) {
    return Rosters.find({'draftId': draft.$loki});
}

function getDraftCurrentPickRoster(draft) {
    return Rosters.find({'$loki': draft.currentPickRosterId})[0];
}

function setDraftCurrentPickRoster(draft, roster) {
    draft.currentPickRosterId = roster.$loki;
}

export { Draft, addDraftCompanies, removeDraftCompanies, getDraftCompanies, addDraftRosters, removeDraftRosters,
    getDraftRosters, getDraftCurrentPickRoster, setDraftCurrentPickRoster }